<div class="replace-matcard">
  <h1 class="cursorDefault">{{project?.title}}</h1>
  <button mat-raised-button class="color" (click)="createProject()">
    <mat-icon class="add">add_box</mat-icon>{{project?.addButton}}
  </button>
  <div class="table-container">
    <table mat-table [dataSource]="dataSource">

      <!-- projectName Column -->
      <ng-container matColumnDef="projectName">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{project?.col1Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.name}}</span>
        </td>
      </ng-container>

      <!-- projectDescription Column -->
      <ng-container matColumnDef="projectDescription">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{project?.col2Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.description}}</span>
        </td>
      </ng-container>

      <!-- projectCreateDate Column -->
      <ng-container matColumnDef="projectCreateDate">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{project?.col3Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.createDate | date}}</span>
        </td>
      </ng-container>

      <!-- projectLastEditDate Column -->
      <ng-container matColumnDef="projectLastEditDate">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{project?.col4Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <span class="tdTextAlignTop">{{element.modifiedDate | date}}</span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="projectActions">
        <th mat-header-cell *matHeaderCellDef class="centerContent"><b>{{project?.col5Titel}}</b></th>
        <td mat-cell *matCellDef="let element" class="tableField">
          <mat-icon class="openCell" title="{{project?.action1}}" (click)="openCellEdit(element.id)">edit</mat-icon>
          <mat-icon class="openCell" title="{{project?.action2}}"
            (click)="openWagonTypeList(element.id)">list</mat-icon>
          <mat-icon class="openCell" title="{{project?.action4}}" (click)="openTrainList(element.id)">train</mat-icon>
          <mat-icon class="delete" title="{{project?.action3}}" (click)="showDeleteDialog(element.id)">
            cancel</mat-icon>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row-effect"></tr>
    </table>
  </div>
</div>
<hr class="line">